"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

document.addEventListener('DOMContentLoaded', function () {
  // Initialise data containers
  var productDataContainer = document.getElementById('ProductData');
  var subscriptionProductDataContainer = document.getElementById('SubscriptionProductData');
  var subscriptionProductData = {};
  var productData = {};
  var productTypes = [];
  var maxProducts = {};
  var subscriptionData = {};
  var totalMealCount = 0;
  var maxMealCount = 22; // Initialise DOM Element variables

  var accordion = document.querySelector('.accordion');
  var accordionItems = accordion.querySelectorAll('.accordion__header');
  var mealItems = document.querySelectorAll('.meal__items');
  var mealCards = document.querySelectorAll('.meal__card');
  var mealPopup = document.querySelector('.meal-popup');
  var addToCartForm = document.querySelector('#AddToCart');
  var addToCartButton = document.querySelector('#AddToCartButton');
  var subscriptionSelector = document.getElementById('SubscriptionFrequency');
  var virtualCart = [];
  var sliders = {};

  var createSlider = function createSlider(container, mealType) {
    var controls = container.parentNode.querySelector('.slider__controls');
    var pageCount = 0;
    var sliderOptions = {
      items: 1,
      edgePadding: 10,
      slideBy: 'page',
      gutter: 20,
      loop: false,
      fixedWidth: 255,
      rewind: true,
      center: true,
      controlsPosition: true,
      nav: false,
      onInit: function onInit(slideInfo) {
        pageCount = Math.ceil(slideInfo.slideCount / slideInfo.slideBy);
        var currPage = 1;
        controls.querySelector('.slider__information .currentSlide').textContent = currPage;
        controls.querySelector('.slider__information .totalSlides').textContent = pageCount;
      },
      responsive: {
        480: {
          items: 2,
          fixedWidth: false
        },
        768: {
          items: 3,
          center: false,
          slideBy: 'page',
          fixedWidth: false,
          mouseDrag: true
        },
        1100: {
          items: 4,
          center: false,
          slideBy: 'page',
          fixedWidth: false,
          edgePadding: 0,
          mouseDrag: true
        }
      }
    };

    var newSliderOptions = _objectSpread({}, sliderOptions, {
      container: container,
      controlsContainer: controls
    });

    sliders[mealType] = new tns(newSliderOptions);
    var slider = sliders[mealType];
    sliders[mealType].events.on('transitionEnd', function (evt) {
      controls.querySelector('.slider__information .currentSlide').textContent = Math.ceil((evt.index + evt.slideBy) / evt.slideBy);
    });
  }; // Check if the data container exists


  if (productDataContainer) {
    var parsedData = JSON.parse(productDataContainer.innerHTML);
    productData = parsedData.products;
    productTypes = parsedData.productTypes;
    maxProducts = parsedData.maxProducts;
    maxMealCount = parsedData.maxMealCount;
    subscriptionData = parsedData.subscription;
  } // Check if the subscription data exists


  if (subscriptionProductDataContainer) {
    subscriptionProductData = JSON.parse(subscriptionProductDataContainer.innerHTML); // selectedVariantId = subscriptionProductData.variants[0].id;
  }

  if (mealItems) {
    mealItems.forEach(function (mealItem) {
      createSlider(mealItem, mealItem.dataset.mealType);
    });
  }

  var findProduct = function findProduct(productId) {
    return productData.find(function (product) {
      return product.id === parseInt(productId, 10);
    });
  };

  var buildPopup = function buildPopup(product) {
    var popupTitle = mealPopup.querySelector('.meal-popup__title');
    var popupSubtitle = mealPopup.querySelector('.meal-popup__subtitle');
    var popupDescription = mealPopup.querySelector('[data-tab="description"]');
    var popupNutrition = mealPopup.querySelector('[data-tab="nutrition"]');
    var popupImage = mealPopup.querySelector('.meal-popup__image');
    var title = product.title;
    var grams = product.tags.find(function (tag) {
      return tag.indexOf('weight:') > -1;
    });
    var image = product.featured_image;
    var splitDescription = product.content.split('<h6>Nutrition</h6>');
    var description = splitDescription[0];
    var nutrition = splitDescription[1];
    popupTitle.textContent = title;

    if (grams) {
      popupSubtitle.textContent = "".concat(grams.split(':'), " grams");
    }

    popupDescription.innerHTML = description;
    popupNutrition.style.pointerEvents = 'none';

    if (nutrition) {
      popupNutrition.innerHTML = nutrition;
    } else {
      popupNutrition.innerHTML = '<p>No nutritional information available</p>';
    }

    popupImage.src = image;
    return true;
  };

  var updateProductCounts = function updateProductCounts() {
    mealCards.forEach(function (mealCard) {
      mealCard.classList.remove('meal__card--active');
    });
    totalMealCount = virtualCart.reduce(function (count, meal) {
      return count + meal.count;
    }, 0);

    if (totalMealCount < maxMealCount) {
      disableFormButtons();
    } else {
      enableFormButtons();
    }

    productTypes.forEach(function (mealType) {
      // Find all the products in the collection that have these meal type
      var mealAccordion = accordion.querySelector("[data-meal-type=\"".concat(mealType, "\"]"));
      var meals = virtualCart.filter(function (meal) {
        return meal.type === mealType;
      }); // Reset the meal cards so we can turn them to active or inactive

      if (meals.length) {
        var maxMeals = maxProducts[mealType];
        var mealCount = meals.reduce(function (count, meal) {
          return count + meal.count;
        }, 0); // Find the meal count for that product type and update it.
        // mealAccordion.querySelector('.meal__count').innerHTML = mealCount + " of " + maxMeals;
        // mealAccordion.querySelector('.meal__progress').style.width = ((mealCount/maxMeals) * 100) + "%";
        // Update the meal cards to show the quantity up or down.

        virtualCart.forEach(function (meal) {
          var mealCard = document.querySelector(".meal__items--".concat(meal.type, " .meal__card[data-meal-id=\"").concat(meal.id, "\"]"));

          if (mealCard && meal.type === 'snacks') {
            mealCard.classList.add('meal__card--active');
            mealCard.querySelector('.meal__quantity').innerHTML = meal.count;
          }
        });

        if (mealCount === maxMeals) {
          // mealAccordion.classList.add('accordion__item--completed');
          mealAccordion.querySelectorAll('.meal__button--plus, .meal__button--add').forEach(function (btn) {
            btn.disabled = true;
          }); // mealAccordion.classList.remove('accordion__item--active');

          if (mealAccordion.nextElementSibling) {
            mealAccordion.nextElementSibling.classList.add('accordion__item--active');
          } else if (subscriptionSelector) {
            // We're at the end of the food items so we should focus on the meal selector.
            subscriptionSelector.focus();
          }
        } else {
          mealAccordion.classList.remove('accordion__item--completed');
          mealAccordion.querySelectorAll('.meal__button--plus, .meal__button--add').forEach(function (btn) {
            btn.disabled = false;
          });
        }
      } else {
        // mealAccordion.querySelector('.meal__count').innerHTML = 0;
        mealAccordion.querySelector('.meal__progress').style.width = '0%';
        mealAccordion.classList.remove('accordion__item--completed');
        mealAccordion.querySelectorAll('.meal__button--plus, .meal__button--add').forEach(function (btn) {
          btn.disabled = false;
        });
      }
    });
    return true;
  };

  var enableFormButtons = function enableFormButtons() {
    if (subscriptionSelector) {
      var selectedVariantId = parseInt(subscriptionSelector.value, 10);

      if (selectedVariantId === 0 || totalMealCount < maxMealCount) {
        return;
      }

      if (addToCartButton) {
        addToCartButton.disabled = false;
      }
    }
  };

  var disableFormButtons = function disableFormButtons() {
    if (addToCartButton) {
      addToCartButton.disabled = true;
    }
  };

  var finishProcessingCart = function finishProcessingCart() {
    addToCartButton.innerHTML = 'Finished...';
    setTimeout(function () {
      addToCartButton.innerHTML = 'Add to Cart';
      disableFormButtons();
      virtualCart = [];
      updateProductCounts();
      window.location = '/cart';
    }, 1000);
    return true;
  };

  if (accordionItems) {
    // Toggle the accordion up or down
    accordionItems.forEach(function (item) {
      item.addEventListener('click', function (evt) {
        if (this.parentNode.classList.contains('accordion__item--active')) return;

        try {
          accordion.querySelector('.accordion__item--active').classList.remove('accordion__item--active');
        } catch (e) {// ignore the error.
        }

        this.parentNode.classList.add('accordion__item--active');
      });
    });
  }
  /**
   * MEAL CARDS
   */


  if (mealCards) {
    mealCards.forEach(function (mealCard) {
      var informationButton = mealCard.querySelector('.meal__information');
      var addToBundle = mealCard.querySelector('.meal__button--add');
      var increaseQuantity = mealCard.querySelector('.meal__button--plus');
      var decreaseQuantity = mealCard.querySelector('.meal__button--minus');
      var mealType = mealCard.dataset.mealType;

      if (informationButton) {
        informationButton.addEventListener('click', function () {
          var product = findProduct(this.dataset.mealId);
          var body = document.querySelector('body');
          mealPopup.style.display = 'block';
          body.classList.add('popup--open');
          buildPopup(product);
        });
      }

      increaseQuantity.addEventListener('click', function (evt) {
        var mealId = parseInt(this.dataset.mealId, 10); // Find the id in the virtual cart

        var mealIndex = virtualCart.findIndex(function (meal) {
          return meal.id === mealId && meal.type === mealType;
        });
        virtualCart[mealIndex].count += 1;
        updateProductCounts();
        return true;
      });
      decreaseQuantity.addEventListener('click', function () {
        var mealId = parseInt(this.dataset.mealId, 10);
        var mealIndex = virtualCart.findIndex(function (meal) {
          return meal.id === mealId && meal.type === mealType;
        });
        virtualCart[mealIndex].count -= 1;

        if (virtualCart[mealIndex].count <= 0) {
          // Remove the item from the virtual cart
          virtualCart = virtualCart.filter(function (meal) {
            return meal.id !== mealId;
          });
        }

        updateProductCounts();
      });
      /**
       * Adding all meals to the virtualCart if they are not snacks.
       */

      if (mealType !== 'snacks') {
        var mealProductId = parseInt(mealCard.dataset.mealId, 10);
        var mealProductQuantityFixedElement = mealCard.querySelector('.meal__quantity--fixed');
        var mealProductQuantity = parseInt(mealProductQuantityFixedElement.dataset.quantity, 10);
        var meal = findProduct(mealProductId);
        var mealId = meal.variants[0].id;
        var mealCategory = meal.type;
        var mealIndex = virtualCart.findIndex(function (meal) {
          return meal.id === mealId;
        }); // var mealType = meal

        if (mealIndex > -1) {
          virtualCart[mealIndex].count = virtualCart[mealId].count + 1;
        } else {
          virtualCart.push({
            id: parseInt(mealProductId, 10),
            variantId: mealId,
            type: mealType,
            category: mealCategory,
            price: meal.price,
            title: meal.title,
            count: mealProductQuantity
          });
        }
      } // Function for build your own meal plan - not fixed meal plans


      if (addToBundle) {
        addToBundle.addEventListener('click', function (evt) {
          evt.preventDefault();
          var mealProductId = parseInt(this.dataset.mealId, 10);
          var meal = findProduct(mealProductId);
          var mealId = meal.variants[0].id;
          var mealCategory = meal.type;
          var mealIndex = virtualCart.findIndex(function (meal) {
            return meal.id === mealId;
          }); // var mealType = meal

          if (mealIndex > -1) {
            virtualCart[mealIndex].count = virtualCart[mealId].count + 1;
          } else {
            virtualCart.push({
              id: parseInt(mealProductId, 10),
              variantId: mealId,
              type: mealType,
              category: mealCategory,
              price: meal.price,
              title: meal.title,
              count: 1
            });
          }

          updateProductCounts();
        });
      }
    });
    updateProductCounts();
  }

  if (mealPopup) {
    var closePopup = mealPopup.querySelector('.meal-popup__close');

    if (closePopup) {
      closePopup.addEventListener('click', function () {
        var body = document.querySelector('body');
        body.classList.remove('popup--open');
        mealPopup.style.display = 'none';
      });
    }

    var popupTabs = mealPopup.querySelectorAll('.meal-popup__tab');

    if (popupTabs) {
      popupTabs.forEach(function (tab) {
        tab.addEventListener('click', function (evt) {
          var activeTab = mealPopup.querySelector('.meal-popup__tab--active');
          var activeContent = mealPopup.querySelector('.meal-popup__text--active');
          var target = mealPopup.querySelector("[data-tab=\"".concat(this.dataset.target, "\"]"));

          if (activeTab) {
            activeTab.classList.remove('meal-popup__tab--active');
            activeContent.classList.remove('meal-popup__text--active');
          }

          this.classList.add('meal-popup__tab--active');

          if (target) {
            target.classList.add('meal-popup__text--active');
          }
        });
      });
    }
  }

  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (evt) {
      evt.preventDefault();
      var selectedVariant;
      var selectedVariantId = parseInt(subscriptionSelector.value, 10);

      if (subscriptionProductData.variants.length > 1) {
        selectedVariant = subscriptionProductData.variants.find(function (variant) {
          return variant.id === selectedVariantId;
        });
      } else {
        var _subscriptionProductD = _slicedToArray(subscriptionProductData.variants, 1);

        selectedVariant = _subscriptionProductD[0];
      }

      var isSubscription = false;
      var subsciptionFrequency = subscriptionData.shipping_interval_frequency;

      if (selectedVariant) {
        if (selectedVariant.public_title === 'One Time Only') {
          // This is the one time only subscription we don't need to add the subscription information to the products
          isSubscription = false;
        } else if (selectedVariant.public_title === 'Weekly') {
          // This is the subscription product we need to add the subscription id and information to the products.
          isSubscription = true;
          subsciptionFrequency = 7;
        } else if (selectedVariant.public_title === 'Monthly') {
          isSubscription = true;
          subsciptionFrequency = 30;
        }
      }

      var bundleId = getUniqueBundleID();
      var productTitle = addToCartForm.getAttribute('data-product-title');
      var bundleProduct = {
        id: selectedVariantId,
        quantity: 1,
        properties: _objectSpread({
          _bundle_product: productTitle,
          _bundle_id: bundleId,
          _is_bundle: true
        }, isSubscription && {
          shipping_interval_frequency: subsciptionFrequency,
          shipping_interval_unit_type: subscriptionData.shipping_interval_unit_type,
          subscription_id: subscriptionData.subscription_id
        })
      };
      var bundleMealItems = virtualCart.map(function (item) {
        return {
          quantity: item.count,
          id: item.variantId,
          properties: _objectSpread({
            _type: item.type,
            _category: item.category,
            _title: item.title,
            _bundle_id: bundleId
          }, isSubscription && {
            recurring_price: 0,
            shipping_interval_frequency: subsciptionFrequency,
            shipping_interval_unit_type: subscriptionData.shipping_interval_unit_type,
            subscription_id: subscriptionData.subscription_id
          })
        };
      });
      var productsToAdd = [].concat(_toConsumableArray(bundleMealItems), [bundleProduct]);

      if (virtualCart.length > 0) {
        addToCartButton.innerHTML = 'Adding meals...';
        axios({
          method: 'POST',
          url: '/cart/add.js',
          data: {
            items: productsToAdd
          }
        }).then(function () {
          finishProcessingCart();
        }).catch(function (error) {
          console.log('Error: ', error);
        });
      }
    });

    var getUniqueBundleID = function getUniqueBundleID() {
      var CHARACTERS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';

      var getChar = function getChar(list) {
        return list[Math.floor(Math.random() * (list.length - 1))];
      };

      var id = '';

      while (id.length < 8) {
        id += getChar(CHARACTERS);
      }

      return id;
    };
  }
});